import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=30506733&scoped=true&"
import script from "./main-content.vue?vue&type=script&lang=js&"
export * from "./main-content.vue?vue&type=script&lang=js&"
import style0 from "./main-content.vue?vue&type=style&index=0&id=30506733&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30506733",
  null
  
)

export default component.exports